import React from 'react';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';

const RefrigeratorsSale = (props) => {
    
    const navigate=useNavigate();
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
    
        return `${day}/${month}/${year}`;
    };
  
    return (
        <div className={props.props.priceResult<0?'Transaction-kh Outcoming-kh':'Transaction-kh Incoming-kh'}>
          
             <div className="parent-kh" onClick={()=>{navigate('EditRefrigeratorSale?Id='+props.props.id)}}>
                <div> <h5><span style={props.props.priceResult<0?{color:'red'}:{color:'green'}} ><NumericFormat decimalScale={1} value={props.props.priceResult} displayType={'text'} thousandSeparator={true} />  ل.س</span> </h5></div>
                <div> <h4> {props.props.buyerName} | <NumericFormat decimalScale={1} value={props.props.totalWeightAfterDiscount_2Percent} displayType={'text'} thousandSeparator={true} /> كغ | <NumericFormat decimalScale={1} value={props.props.totalSalesPriceOfAll} displayType={'text'} thousandSeparator={true} />  ل.س </h4></div>
                <div> <h5>{formatDate(props.props.date)}</h5></div>
                <div> <h5> <span
                        style={props.props.customerName===""?{
                        display: "inline-block",
                        minWidth: "50px",
                        borderBottom: "1px solid black",
                        textAlign: "center",
                        verticalAlign: "middle",
                        }:{}}
                    > {props.props.customerName} </span> |  <NumericFormat decimalScale={1} value={props.props.totalWeightAfterDiscount_2Percent2} displayType={'text'} thousandSeparator={true} /> كغ | <NumericFormat decimalScale={1} value={props.props.totalSalesPriceOfAll2} displayType={'text'} thousandSeparator={true} />  ل.س  </h5></div>
            </div>
            
           
        </div>
    );
}

export default RefrigeratorsSale;
